// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取小程序模板消息列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /wx-ma/template/list */
export async function wxMaTemplateListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListMaWxTemplateResp>('/wx-ma/template/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 订阅小程序模板消息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /wx-ma/template/subscribe */
export async function wxMaTemplateSubscribeUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.wxMaTemplateSubscribeUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/wx-ma/template/subscribe', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
